import {shortenEnv} from "../../Const";

export const CTG_PROTOCOL = 'ctg';
export const ALPHALISA_PROTOCOL = 'alphalisa';

export const dataConversionApiConsts = {
    API_NAME: "data-conversion", // This name needs to be the same as the name of the API in the App.tsx file
    DATABASE_NAME: "lab_to_cdd_conversion",
    TABLE_NAME: `${shortenEnv}-lab-to-cdd-conversion-api-records`,
    path: {
        CONVERT_CTG_ALPHALISA: "/v1/conversion/ctg_alphalisa",
        CONVERT_IC50_BINDING: "/v1/conversion/ic50_binding"
    },
}

export const DATA_CONVERSION_BUCKET_NAME = `${shortenEnv}-lab-to-cdd-conversion-api-user-uploads-and-script-outputs`

export const Z_PRIME_VALUE_THRESHOLD = 0.6
